module.exports = __webpack_public_path__ + "static/media/sv.abfac59c.svg";